import React from 'react';
import { BiBook, BiPlusCircle, BiBookOpen } from 'react-icons/bi';
import { useNavigate } from 'react-router-dom';

const SidebarFilters = ({
  selectedProviderType,
  handleProviderTypeChange,
  handleSearch,
  handleClearFilters,
  origin,
  destination,
  setOrigin,
  setDestination,
  fetchPortSuggestions,
  sidebarOriginSuggestions = [],
  sidebarDestinationSuggestions = [],
  onSidebarOriginChange,
  onSidebarDestinationChange,
  setOriginSuggestions,
  setDestinationSuggestions
}) => {
  const navigate = useNavigate();

  const handleGuideClick = (e) => {
    e.preventDefault();
    navigate(`/routing-guide?providerType=${selectedProviderType}`);
  };

  return (
    <div>
      <nav>
        <ul>
          <li>
            <a href="/routing-guide" onClick={handleGuideClick}>
              <BiBook /> {selectedProviderType ? `Selected Guide: ${selectedProviderType}` : 'Select a Guide'}
            </a>
          </li>
          {selectedProviderType && (
            <>
              <li>
                <a href="#list-routes" onClick={() => navigate(`/routing-guide/list?providerType=${selectedProviderType}`)}>
                  <BiBookOpen /> View Routing Guides
                </a>
              </li>
            </>
          )}
        </ul>
      </nav>
    </div>
  );
};

export default SidebarFilters;
